import { render } from "./content.vue?vue&type=template&id=dc0df422&scoped=true"
const script = {}

import "./content.vue?vue&type=style&index=0&id=dc0df422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0df422"]])

export default __exports__